@let timeLeft = interval | async;

<mbs-button
  [size]="size.md"
  [isCtrl]="true"
  [icon]="'ico ico-Refresh'"
  [disabled]="!isResendAvailable || loading"
  (click)="onClick()">
  @if (isResendAvailable) {
    Resend code
  } @else {
    Resend code after {{ timeLeft }} sec.
  }
</mbs-button>
